/**
 * Add space between camelCase text.
 * @param {string} String in Camel Case format e.g. camelCased
 * @returns {string} Converted string with space between camelCase text e.g. camel cased
 */
export var unCamelCase = function unCamelCase(camelCasedString) {
  if (camelCasedString) {
    return camelCasedString.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2').toLowerCase();
  }

  return '';
};
//# sourceMappingURL=helpers.js.map